import PropTypes from 'prop-types';
import Flatpickr from "react-flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

function InputMes({ name, value, onChange }) {

    return (
        <div>
            <Flatpickr
                id={name}
                name={name}
                value={value || ""}
                onChange={(date) => onChange(date[0])}
                options={{
                    disableMobile: true,
                    locale: Portuguese,
                    plugins: [
                        new monthSelectPlugin({
                            'shorthand': true,
                            'dateFormat': "m/Y",
                            'altFormat': "F Y",
                            'theme': "light"
                        })
                    ]
                }}
                className="border p-2 rounded form-control"
            />
        </div>
    )
}

export default InputMes

// DataMesGeraRel.propTypes = {
//     setData: PropTypes.func.isRequired,
// };